interface WeeklyApiData {
  days: number;
  count: number;
}

interface ChartData {
  day: string;
  value: number;
  dayIndex: number;
}

const DAY_NAMES = ["월", "화", "수", "목", "금", "토", "일"];

export const transformWeeklyData = (apiData: WeeklyApiData[]): ChartData[] => {
  const weekData: ChartData[] = DAY_NAMES.map((day, index) => ({
    day,
    value: 0,
    dayIndex: index,
  }));

  apiData.forEach((item) => {
    if (item.days >= 0 && item.days <= 6) {
      weekData[item.days] = {
        day: DAY_NAMES[item.days],
        value: item.count,
        dayIndex: item.days,
      };
    }
  });

  return weekData;
};

export const sortByToday = (data: ChartData[]): ChartData[] => {
  const today = new Date().getDay(); // 0=일, 1=월, ..., 6=토
  const mondayBasedToday = today === 0 ? 6 : today - 1; // 0=월 기준으로 변환

  return [...data.slice(mondayBasedToday), ...data.slice(0, mondayBasedToday)];
};
